module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_h_r1_l1-19_dark.3ecc705a.svg";